import Svadhi1 from '../../../Media/BSD/Tanakayu/Tanakayu Svadhi.webp'
import Svadhi2 from '../../../Media/BSD/Tanakayu/Tanakayu Svadhi.webp'





const Svadhiimages =[
Svadhi1,Svadhi2
]

export default Svadhiimages;